var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.4444V8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8V12",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1111 9.77777C11.1111 9.22549 11.5588 8.77777 12.1111 8.77777H14C14.5523 8.77777 15 9.22549 15 9.77777V14C15 14.5523 14.5523 15 14 15H12.1111C11.5588 15 11.1111 14.5523 11.1111 14V9.77777Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88892 9.77777C4.88892 9.22549 4.4412 8.77777 3.88892 8.77777H2.00003C1.44774 8.77777 1.00003 9.22549 1.00003 9.77777V14C1.00003 14.5523 1.44774 15 2.00003 15H3.88892C4.4412 15 4.88892 14.5523 4.88892 14V9.77777Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.08be30463992827e13aa5b2cf6db584d.svg";
export { ForwardRef as ReactComponent };